import styles from "./styles/link.module.scss";

export const CustomLink = (link: string, text: string, color?: string) => {
  return (
    <a
      className={styles.link}
      style={{ color: color ?? "#3d77f5" }}
      href={link}
      target="_Blank"
      rel="noreferrer"
    >
      {text}
    </a>
  );
};
